// Site-wide constants for HAZ Insulation

export const COMPANY = {
    name: "HAZ Insulation",
    legal: "HAZ Insulation",
    tagline: "Energy Efficiency, Done Right.",
    phone: "(708) 770-4461",
    phoneHref: "tel:+17087704461",
    email: "hazjames@haz-insulation.com",
    emailHref: "mailto:hazjames@haz-insulation.com",
    hours: "Mon–Sat · 7:30am – 6:00pm",
    yearsCombined: 50,
    fiveStarReviews: 50,
    nicorPartner: true,
    maxRebate: "$1,800",
    homesRetrofitted: "500+",
};

// Services — descriptions written by HAZ team (carried over from Squarespace site)
export const SERVICES = [
    {
        id: "spray-foam",
        title: "Spray Foam Insulation",
        kicker: "Flagship",
        blurb:
            "Open & closed-cell spray foam — applied in controlled layers to seal gaps and cavities for an airtight envelope.",
        details:
            "We start by inspecting the area, fixing moisture issues, and masking off surfaces. Crews wear full protective gear with proper ventilation set up. We mix and calibrate the foam equipment for correct temperature and pressure, then apply it evenly in controlled layers. Finally we trim excess and confirm the install is airtight and meets performance standards. (Jamie adding closed-cell spray foam to knee walls — 5.5\" R38, to code.)",
        bullets: ["Highest R/inch", "Air & vapor barrier", "Cuts HVAC load"],
    },
    {
        id: "cellulose",
        title: "Blow-In Insulation",
        kicker: "Flagship",
        blurb:
            "Blown-in fiberglass or cellulose, evenly distributed to the right depth for the desired R-value.",
        details:
            "We inspect attic or wall cavities for air leaks, moisture, and proper ventilation. Gaps around pipes, wires, and openings are sealed first to improve efficiency. Then we set up the blowing machine and prepare the loose-fill material — fiberglass or cellulose — and blow it in evenly to the correct depth. We confirm vents stay clear and coverage is uniform. (Jamie blowing insulation.)",
        bullets: ["Eco-friendly", "Sound dampening", "NICOR rebate eligible"],
    },
    {
        id: "attics",
        title: "Attic Insulation",
        blurb:
            "Top-down attic systems — air seal, insulate, and ventilate. The right way, every time.",
        details:
            "We start by inspecting the space for air leaks, moisture issues, and proper ventilation. The crew seals gaps and cracks around ducts, wiring, and openings to improve energy efficiency. We then choose the appropriate insulation material and R-value for the climate and code, install with even coverage (without blocking vents or compressing material), and verify consistent thickness and proper airflow.",
    },
    {
        id: "insulation-removal",
        title: "Insulation Removal",
        blurb:
            "Safe, contained removal of old, damaged, or contaminated insulation — including varmint-infested loose fill.",
        details:
            "We inspect the attic for hazards like mold, pests, or asbestos and set up proper ventilation. Crews wear gloves, goggles, and respirators. Specialized vacuums remove the old insulation while minimizing dust and debris. Material is sealed in heavy-duty bags and disposed of per local regulations. The space is then cleaned and sanitized, ready for new insulation if needed. (Denni in proper gear removing varmint-infested loose fill.)",
    },
    {
        id: "crawl-spaces",
        title: "Crawl Space Encapsulation",
        blurb:
            "Vapor barrier, sealing, and insulation that ends cold floors and humidity issues for good.",
        details:
            "We inspect for moisture, standing water, pests, and structural issues. Vents and gaps get sealed, then a heavy-duty vapor barrier is installed across the ground and up the walls. Seams are overlapped and taped tight, with the liner secured to create a continuous moisture barrier. We may add insulation and a dehumidifier to control humidity. Finally we confirm the space is fully sealed and dry. (Mr. Martinez's crawl space in Illinois — 3 days of work.)",
    },
    {
        id: "commercial",
        title: "Commercial Insulation",
        blurb:
            "Spray foam, fiberglass, or rigid board for commercial buildings — coordinated to your construction schedule.",
        details:
            "We review building plans and assess energy codes, safety, and site conditions. We coordinate with other trades so insulation work fits the construction schedule and system layouts. Materials are selected based on performance and building use. Specialized equipment lets us cover large areas efficiently while sealing air leaks and thermal bridges. We finish with full inspection for compliance, coverage, and energy-efficiency standards. (Jamie and the crew filling a commercial building.)",
    },
    {
        id: "dense-packing",
        title: "Wall Insulation — Dense Pack",
        blurb:
            "High-density wall fills that stop drafts cold in older Chicagoland homes — no drywall demo.",
        details:
            "We drill small access holes in the siding or interior wall, then inject cellulose at high density (3.5+ lbs/cu ft) so the wall cavity is packed solid with no settling or voids. Holes are plugged and finished. You get a quieter, draft-free wall with a real R-value upgrade — without tearing into your finished living space. Ideal for bungalows, foursquares, and pre-1970s ranches.",
    },
    {
        id: "batt-fiberglass",
        title: "Batt Fiberglass",
        blurb: "Standard and high-density fiberglass batts for new construction and renovations.",
        details:
            "We size batts to fit each cavity precisely — no compression, no gaps, no fishmouths around wiring or plumbing. Vapor barriers are installed per code for your climate zone. Best fit for new construction, additions, garages, and finished basements where stud bays are open and accessible.",
    },
    {
        id: "hvac",
        title: "Heating & Air Conditioning",
        blurb: "Duct sealing and HVAC services that pair with your insulation upgrade.",
        details:
            "Leaky ducts can waste 20–30% of conditioned air before it reaches your rooms. We seal supply and return ducts with mastic and metal tape, insulate ducts in unconditioned spaces, and verify static pressure. Combined with attic air sealing, this is one of the highest-ROI moves you can make in an older home.",
    },
    {
        id: "gutters",
        title: "Gutters",
        blurb: "Gutter installation and protection — keep water away from your envelope.",
        details:
            "Bad drainage is the #1 enemy of insulation. We install seamless 5\" or 6\" aluminum gutters, properly pitched downspouts, and gutter guards to keep leaves out. Done together with your insulation work, your home stays dry, your basement stays dry, and your walls stop wicking moisture into the cavities we just packed.",
    },
    {
        id: "varmint-removal",
        title: "Varmint Removal",
        blurb: "Humane wildlife removal and entry-point sealing for attics and crawl spaces.",
        details:
            "Squirrels, raccoons, mice, bats — they get into attics and contaminate insulation with droppings, urine, and chewed wiring. We trap or exclude them humanely, identify and seal every entry point (eaves, soffits, roof vents, foundation gaps), then remove and replace the contaminated insulation. Pairs with our Insulation Removal service.",
    },
    {
        id: "mold-ventilation",
        title: "Mold & Ventilation",
        blurb: "Mold remediation and proper attic / bath ventilation done to code.",
        details:
            "Most attic mold isn't a mold problem — it's a moisture problem caused by bad ventilation and bath fans dumping into the attic. We remediate the mold, then fix the root cause: balanced soffit-to-ridge ventilation, baffles to keep airflow open, and bath/dryer fans ducted properly through the roof or wall. The mold doesn't come back.",
    },
    {
        id: "air-sealing",
        title: "Air Sealing",
        blurb: "Stop drafts at the source — caulk, foam, and weatherstripping at every leak point.",
        details:
            "Air sealing is the single highest-ROI move in any older home. We trace airflow at top plates, can lights, attic hatches, rim joists, and around HVAC penetrations — then seal each one with the right material (fire-rated foam at chases, caulk at framing, gasket kits at hatches). Pairs with attic and wall insulation for a real envelope upgrade. Verified with a blower door test before-and-after.",
    },
    {
        id: "energy-audit",
        title: "Home Energy Audit",
        blurb: "Full BPI-style diagnostic — thermal imaging + blower door + moisture mapping.",
        details:
            "We bring a calibrated blower door, thermal camera, moisture meters, and a CO/combustion analyzer. You get a written report showing exactly where energy and dollars are leaving — with a prioritized fix list and rebate eligibility flagged for each item. This is the same audit format the energy auditors use, performed by a BPI-certified owner-operator.",
    },
    {
        id: "nicor-rebates",
        title: "NICOR & ComEd Rebates",
        blurb: `Up to ${"$1,800"} in NICOR rebates — we file the paperwork for you.`,
        details:
            "We are an approved NICOR Gas and ComEd rebate contractor. Eligible attic insulation and air-sealing jobs typically qualify for $1,000–$1,800 back, with bonus rebates stacked on for low-income and high-efficiency homes. We pre-qualify your home, file all paperwork, and the check comes directly to you — usually within 6–8 weeks of completion.",
    },
];

// Real crew (carried over from Squarespace site captions)
export const CREW = [
    { name: "Jamie", role: "Spray Foam · Blow-In · Commercial", note: "Closed-cell to code, R38 knee walls." },
    { name: "Jose", role: "Attic Insulation · Blow-In", note: "Killing attics with blown-in." },
    { name: "Denni", role: "Insulation Removal", note: "Full-gear removal of contaminated loose fill." },
    { name: "Juan", role: "Commercial Insulation", note: "Large-format commercial fills." },
];

export const SERVICE_AREAS = [
    { city: "Tinley Park", state: "IL", zip: "60477", slug: "tinley-park" },
    { city: "Orland Park", state: "IL", zip: "60462", slug: "orland-park" },
    { city: "Mokena", state: "IL", zip: "60448", slug: "mokena" },
    { city: "Monee", state: "IL", zip: "60449", slug: "monee" },
    { city: "Frankfort", state: "IL", zip: "60423", slug: "frankfort" },
    { city: "Lemont", state: "IL", zip: "60439", slug: "lemont" },
    { city: "Chicago — South Loop", state: "IL", zip: "60605", slug: "chicago-south-loop" },
    { city: "Highland", state: "IN", zip: "46322", slug: "highland-in" },
    { city: "Schererville", state: "IN", zip: "46375", slug: "schererville-in" },
    { city: "Flossmoor", state: "IL", zip: "60422", slug: "flossmoor" },
    { city: "Glenwood", state: "IL", zip: "60425", slug: "glenwood" },
    { city: "Homewood", state: "IL", zip: "60430", slug: "homewood" },
    { city: "South Holland", state: "IL", zip: "60473", slug: "south-holland" },
    { city: "Alsip", state: "IL", zip: "60803", slug: "alsip" },
    { city: "South Chicago", state: "IL", zip: "60617", slug: "south-chicago" },
    { city: "Park Forest", state: "IL", zip: "60466", slug: "park-forest" },
    { city: "Oak Lawn", state: "IL", zip: "60453", slug: "oak-lawn" },
    { city: "Berwyn", state: "IL", zip: "60402", slug: "berwyn" },
];

export const TESTIMONIALS = [
    {
        name: "Andy R.",
        location: "Palos Park, IL",
        rating: 5,
        verified: "Google review · Titanium Insulation",
        text:
            "I cannot recommend them enough. They re-insulated our entire attic and the experience was top-notch from start to finish. Even with sub-zero weather, the crew showed up ready to work — extreme cold didn't slow them down or affect the quality. Our rep, James, was fantastic: extremely knowledgeable, took the time to explain our options, and incredibly personable. Fast without cutting corners, very respectful of our home, kept the workspace clean. Fair pricing for the level of service. If you're looking for a reliable insulation company in Chicagoland, look no further — ask for James!",
    },
    {
        name: "Natosha L.",
        location: "Chicagoland",
        rating: 5,
        verified: "Google review · Titanium Insulation",
        text:
            "James came out, gave me a quote, we set up an appointment, work completed. Professional service and extremely satisfied with service provided — installation of my crawl space, garage, and attic. Provided pictures and videos along the way! I highly recommend if you're looking for exceptional service.",
    },
    {
        name: "Karen H.",
        location: "Chicagoland",
        rating: 5,
        verified: "Google review · Titanium Insulation",
        text:
            "James was very prompt to come and provide a reasonable quote for adding insulation to my entire attic. They actually did the work the very next day! I have been very pleased that my roof has remained snow-covered, proving to me that heat is no longer being transferred from my living space into the attic. James was very personable and patient answering all my questions.",
    },
    {
        name: "Adam G.",
        location: "Chicagoland",
        rating: 5,
        verified: "Google review · Titanium Insulation",
        text:
            "Fantastic job! James and his team were great. I wanted my oversized garage insulated and they got it done quickly and efficiently. I compared quotes from four companies — their price was significantly better. Very pleased and I recommend them to anyone who wants a great price without sacrificing quality.",
    },
    {
        name: "Eric N.",
        location: "Cape Cod home, Chicagoland",
        rating: 5,
        verified: "Google review · Titanium Insulation",
        text:
            "Fantastic from start to finish. We were on a tight schedule after our tenant moved out — existing insulation in our upstairs Cape Cod bedrooms was inadequate. James knew how to maximize R-value in a tight spot and gave us a real solution: conditioned attic with spray foam in the rafters. I've walked through a dozen of these homes — we now have the best-insulated Cape Cod in the neighborhood. He went above and beyond, kept us on schedule, even referred us to a drywall contractor we ended up loving. Quick to respond to texts and calls, updates each step of the way. Money well spent.",
    },
    {
        name: "Marcus L.",
        location: "Orland Park, IL",
        rating: 5,
        text:
            "James Minsky and his crew dense-packed our 1960s ranch and the upstairs is finally usable in winter. On-time, clean, and James walked me through the NICOR rebate paperwork himself.",
    },
    {
        name: "Jennifer P.",
        location: "Frankfort, IL",
        rating: 5,
        text:
            "Jamie sprayed closed-cell foam in our attic and our gas bill dropped almost in half the first month. James was straight with us on what we needed and what we didn't. Best home investment we've made in 12 years.",
    },
    {
        name: "Dave R.",
        location: "Highland, IN",
        rating: 5,
        text:
            "I'm a GC and I sub HAZ on every insulation package now. James Minsky is reachable, his crew shows up clean and on time, and the inspector loves their work. Zero callbacks.",
    },
    {
        name: "Sandra K.",
        location: "Tinley Park, IL",
        rating: 5,
        text:
            "Crawl space encapsulation was a game changer — no more cold floors and the dehumidifier readings are perfect. James walked the space with me before and after. Three days of work, exactly as quoted.",
    },
    {
        name: "Tom B.",
        location: "Lemont, IL",
        rating: 5,
        text:
            "Got three quotes — HAZ wasn't the cheapest, but the difference in scope was night-and-day. James Minsky actually inspected the attic instead of guessing from a doorway. That's why we hired him.",
    },
    {
        name: "Erika S.",
        location: "Mokena, IL",
        rating: 5,
        text:
            "Jamie sealed every chase, can light, and top plate before insulating. That's the kind of detail you don't usually see, and James made sure it got done before they blew anything in.",
    },
];

export const TRUST_STATS = [
    { value: "50+", label: "Five-Star Reviews", sub: "in the last 18 months" },
    { value: "50", label: "Years Combined", sub: "HAZ Insulation" },
    { value: "1→13", label: "Trucks Scaled", sub: "Founder track record" },
    { value: "NICOR", label: "Rebate Partner", sub: "Energy-efficiency programs" },
];

export const IMAGES = {
    hero: "https://images.pexels.com/photos/4469146/pexels-photo-4469146.jpeg",
    sprayFoam:
        "https://images.squarespace-cdn.com/content/v1/69ea7d351dcd56282329dff8/9d78586c-6dd6-4541-bfc0-a5baa5974644/OIP+%282%29.webp",
    blowIn:
        "https://images.squarespace-cdn.com/content/v1/69ea7d351dcd56282329dff8/3f20b2df-5f37-4a6d-a992-806739ab88c8/OIP+%281%29.webp",
    attic:
        "https://images.squarespace-cdn.com/content/v1/69ea7d351dcd56282329dff8/b04dfd21-2946-4955-8e9a-1edef2f082b6/how-to-blow-insulation-in-an-attic-1695959059.jpg",
    removal:
        "https://images.squarespace-cdn.com/content/v1/69ea7d351dcd56282329dff8/4e78abff-15bf-4e06-9aa5-d31fd5ad0f49/R+%281%29.jpg",
    crawlSpace:
        "https://images.squarespace-cdn.com/content/v1/69ea7d351dcd56282329dff8/384d16fc-d869-4204-ad86-d322e888d806/Encapsulated-crawl-space-in-crawl-space-finished-job.jpg",
    commercial:
        "https://images.squarespace-cdn.com/content/v1/69ea7d351dcd56282329dff8/bb9ea8be-67cb-48c3-b32a-c16c6eb979ac/Restoration2-1.jpg",
    batt: "https://images.pexels.com/photos/6124239/pexels-photo-6124239.jpeg",
    contractor:
        "https://images.unsplash.com/photo-1679797850019-3d0d8659a695?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBjb250cmFjdG9yJTIwd29ya2luZ3xlbnwwfHx8fDE3NzcyNDQ5OTB8MA&ixlib=rb-4.1.0&q=85",
    chicago:
        "https://images.unsplash.com/photo-1493134606758-a812d6f616be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxjaGljYWdvJTIwc2t5bGluZSUyMHdhcm0lMjBsaWdodHxlbnwwfHx8fDE3NzcyNDUwMDB8MA&ixlib=rb-4.1.0&q=85",
};

// Real major clients (carried over from founder's track record)
export const MAJOR_CLIENTS = [
    "Celtic Homes",
    "Dunkin' Donuts",
    "3F Construction",
    "Carson Construction",
];

// Per-service photo overrides (real job photos from HAZ crew, carried over from Squarespace)
export const SERVICE_IMAGES = {
    "spray-foam":
        "https://images.squarespace-cdn.com/content/v1/69ea7d351dcd56282329dff8/9d78586c-6dd6-4541-bfc0-a5baa5974644/OIP+%282%29.webp",
    cellulose:
        "https://images.squarespace-cdn.com/content/v1/69ea7d351dcd56282329dff8/3f20b2df-5f37-4a6d-a992-806739ab88c8/OIP+%281%29.webp",
    attics:
        "https://images.squarespace-cdn.com/content/v1/69ea7d351dcd56282329dff8/b04dfd21-2946-4955-8e9a-1edef2f082b6/how-to-blow-insulation-in-an-attic-1695959059.jpg",
    "insulation-removal":
        "https://images.squarespace-cdn.com/content/v1/69ea7d351dcd56282329dff8/4e78abff-15bf-4e06-9aa5-d31fd5ad0f49/R+%281%29.jpg",
    "crawl-spaces":
        "https://images.squarespace-cdn.com/content/v1/69ea7d351dcd56282329dff8/384d16fc-d869-4204-ad86-d322e888d806/Encapsulated-crawl-space-in-crawl-space-finished-job.jpg",
    commercial:
        "https://images.squarespace-cdn.com/content/v1/69ea7d351dcd56282329dff8/bb9ea8be-67cb-48c3-b32a-c16c6eb979ac/Restoration2-1.jpg",
};
